import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";
const baseUrl = `${CONFIG.BASE_URL}/wayapay-settlement-service/api/v1`;

// Commissions & Payouts
export const updateCommissionPayout = async ({ id, ...payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin-pricing/commission-payouts/${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createCommissionPayout = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin-pricing/commission-payouts`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleCommissionPayout = async ({ id, isActive }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/commission-payouts/${id}/status?isActive=${isActive}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAllCommissionPayouts = async (params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/commission-payouts`,
      {
        params: queryParams,
      },
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};

export const updateCommission = async ({ id, ...payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin-pricing/commissions/${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createCommission = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin-pricing/commissions`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleCommission = async ({ id, isActive }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/commissions/${id}/status?isActive=${isActive}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAllCommission = async (params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/commissions`,
      {
        params: queryParams,
      },
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};

// Product Category Fees

export const changeUserCategory = async ({ id, categoryId }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/categories/users/${id}`,
      null,
      {
        params: { categoryId },
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
export const getUsersOfCategory = async (id, params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim()) {
    queryParams.search = params.search.trim();
  }
  if (params.page !== undefined) {
    queryParams.page = params.page;
  }
  if (params.size !== undefined) {
    queryParams.size = params.size;
  }

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/categories/${id}/users`,
      {
        params: queryParams,
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};

export const getProfitCalculation = async (params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/categories/profit-calculation`,
      {
        params: queryParams,
      },
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};

export const updateProductCategoryFee = async ({ id, ...payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin-pricing/product-category-fees/${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createProductCategoryFee = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin-pricing/product-category-fees`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleCategoryProductFee = async ({ id, isActive }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/product-category-fees/${id}/status?isActive=${isActive}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const updateProductCategory = async ({ id, ...payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin-pricing/categories/${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const setProductCategoryAsDefault = async ({ id }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/categories/${id}/default`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleProductCategory = async ({ id, isActive }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/categories/${id}/status?isActive=${isActive}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const updateProduct = async ({ id, ...payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin-pricing/products/${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleProduct = async ({ id, isActive }) => {
  try {
    const response = await axiosInstance.patch(
      `${baseUrl}/admin-pricing/products/${id}/status?isActive=${isActive}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createNewProduct = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin-pricing/products`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createProductCategory = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin-pricing/categories`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAllProducts = async (params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/products`,
      {
        params: queryParams,
      },
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};

export const getProductCategoryFeesByCategoryId = async ({ id, params }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/product-category-fees/by-category/${id}`,
      { params },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getProductCategoryFees = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/product-category-fees`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getCategoryById = async ({ categoryId }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/categories/${categoryId}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getProductCategories = async (params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim()) {
    queryParams.search = params.search.trim();
  }
  if (params.page !== undefined) {
    queryParams.page = params.page;
  }
  if (params.size !== undefined) {
    queryParams.size = params.size;
  }
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin-pricing/categories`,
      {
        params: queryParams,
      },
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
